import store from '@/store/index.js'
let dic = store.state.dic;

export default function Configs(that) {

    const searchItems = [
        // {
        //     label: "考生号",
        //     span: 8,
        //     placeholder: '请输入考生号',
        //     model: "11",
        // },
        // {
        //     label: "学号",
        //     prop: "studentId",
        //     span: 8,
        //     placeholder: '请输入学号',
        //     model: "22",
        // },
        {
            label: "姓名",
            span: 8,
            placeholder: '请输入身份证号',
            model: "name",
        },
        {
            label: "事项名称",
            span: 8,
            placeholder: '请输入事项名称',
            model: "linkName",
        },
        {
            label: "办理状态",
            span: 8,
            placeholder: '请选择',
            model: "status",
            type: 'select',
            options: dic._STATUS
        },
    ]
    const tableColumns = [
        {
            label: "id",
            name: "id",
            prop:"id",
            align: "center",
            show: false
        },
        {
            label: "姓名",
            name: "personId",
            prop:"personId",
            align: "center",
            show: true
        },
        {
            label: "事项名称",
            name: "linkName",
            prop:"linkName",
            align: "center",
            show: true
        },
        {
            label: "班级",
            name: "className",
            prop:"className",
            align: "center",
            show: true
        },
        /*{
            label: "缴费审核",
            prop: "11",
            align: "center",
            show: true
        },*/
        {
            label: "描述",
            name: "description",
            prop:"description",
            align: "center",
            show: true
        },{
            label: "办理状态",
            name: "status",
            // prop:"status",
            align: "center",
            show: true,
            function(){

            }
        },
        // {
        //     label: "状态",
        //     prop: "22",
        //     align: "center",
        //     show:true
        // },
        // {
        //     label: "注意事项",
        //     prop: "33",
        //     align: "center",
        //     show: true
        // },

        {
            label: "操作",
            name: "custom",
            align: "center",
            width:'260px',
            show:true
          }
    ]
    const formItems = [
        {
            label: "姓名",
            span: 8,
            disabled: true,
            // placeholder: '请输入姓名',
            model: "11",
        },
        {
            label: "学院",
            span: 8,
            disabled: true,
            model: "22",
            type: 'select',
            // placeholder: '请选择学院',
        },
        {
            label: "系别",
            span: 8,
            disabled: true,
            model: "33",
            type: 'select',
            // placeholder: '请选择系别',
        },
        {
            label: "专业",
            span: 8,
            disabled: true,
            model: "44",
            type: 'select',
            // placeholder: '请选择专业',
        },
        {
            label: "班级",
            span: 8,
            disabled: true,
            model: "55",
            type: 'select',
            // placeholder: '请选择班级',
        },
    ]

    const formRules = {
        11: [{
            required: true,
            trigger: "blur",
            message: '请选择点位类别'
        }],
        22: [{
            required: true,
            trigger: "blur",
            message: '请输入点位名称'
        }],
        33: [{
            required: true,
            trigger: "blur",
            message: '请输入经度'
        }],
        44: [{
            required: true,
            trigger: "blur",
            message: '请输入纬度'
        }],
        55: [{
            required: true,
            trigger: "blur",
            message: '请选择所属院系'
        }],
        66: [{
            required: true,
            trigger: "blur",
            message: '请选择负责人'
        }],
        77: [{
            required: true,
            trigger: "blur",
            message: '请选择值班人'
        }],
        88: [{
            required: true,
            trigger: "blur",
            message: '请选择事项'
        }],
    }
    return {
        searchItems,
        tableColumns,
        formItems,
        formRules
    }
}
